import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { MessageSquare, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaPendenciaCriada = (acao: string): boolean => {
    const acaoLower = acao.toLowerCase().trim();
    return acaoLower.includes('pendência criada') || acaoLower.includes('pendencia criada') || acaoLower === 'pendência criada';
};

const getIconPendenciaCriada = (acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: MessageSquare, color: 'var(--c2e86de)' };
};

export default function CardPendenciaCriada({ item, onNavigateToFile, isExpanded, onToggleExpand }: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconPendenciaCriada(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={<ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />}
        />
    );
}

export const pendenciaCriadaConfig = {
    tipo: 'pendencia_criada',
    detectaTipo: detectaPendenciaCriada,
    getIcon: getIconPendenciaCriada,
    temExpansao: () => true,
    Component: CardPendenciaCriada
};

